<p-toast></p-toast>
<div *ngIf="error === 'noaccesstoken'">
  <h1>Manglende access token</h1>
  <p>
    Du ikke logget korrekt ind via NemLogin. Kontakt KOMBIT helpdesk på 89 87 21
    37 eller
    <a href="mailto:helpdesk@serviceplatformen.dk"
      >helpdesk@serviceplatformen.dk</a
    >, hvis du mener det er en fejl.
  </p>
  <button pButton type="button" (click)="logout()">Log af</button>
</div>

<div *ngIf="error === 'noroles'">
  <h1>Ingen roller</h1>
  <p>
    Dit login er ikke knyttet til nogen roller i NemLogin - kontakt venligst din
    NemLogin-administrator.<br />
    Hvis du mener, at du har de korrekte roller, så kontakt KOMBIT helpdesk på
    89 87 21 37 eller
    <a href="mailto:helpdesk@serviceplatformen.dk"
      >helpdesk@serviceplatformen.dk</a
    >.
  </p>
  <button pButton type="button" (click)="logout()">Log af</button>
</div>

<div *ngIf="error === 'acceptTerms'">
</div>

<div *ngIf="error === 'noAcceptedTerms'">
  <h1>Vilkår og betingelser afvist</h1>
  <p>
    Da vilkår og registreringspraksis ikke er blevet accepteret, vil adgangen til de ønskede komponenter ikke kunne gennemføres.
    Kontakt KOMBIT helpdesk på 89 87 21 37 eller
    <a href="mailto:helpdesk@serviceplatformen.dk"
      >helpdesk@serviceplatformen.dk</a
    >, hvis du mener det er en fejl eller for at blive oprettet.
  </p>
  <button pButton type="button" (click)="logout()">Log af</button>
</div>

<div *ngIf="error === 'noorganisation'">
  <h1>Ingen organisation fundet</h1>
  <p>
    Det CVR nummer du er logget ind med findes ikke i Admininistrationsmodulet.
    Kontakt KOMBIT helpdesk på 89 87 21 37 eller
    <a href="mailto:helpdesk@serviceplatformen.dk"
      >helpdesk@serviceplatformen.dk</a
    >, hvis du mener det er en fejl eller for at blive oprettet.
  </p>
  <button pButton type="button" (click)="logout()">Log af</button>
</div>

<div *ngIf="error === 'serverdown'">
  <h1>Serveren er nede</h1>
  <p>
    Beklager, men der er i øjeblikket problemer med serveren. Kontakt KOMBIT
    helpdesk på 89 87 21 37 eller
    <a href="mailto:helpdesk@serviceplatformen.dk"
      >helpdesk@serviceplatformen.dk</a
    >.
  </p>
  <button pButton type="button" (click)="logout()">Log af</button>
</div>

<div *ngIf="error === 'admrolesetup'">
  <h1>Ugyldig rolletildeling</h1>
  <p>
    Du er tildelt både rollen som forvalter administrator og én eller flere
    andre roller, hvilket ikke er tilladt. Kontakt KOMBIT helpdesk på 89 87 21
    37 eller
    <a href="mailto:helpdesk@serviceplatformen.dk"
      >helpdesk@serviceplatformen.dk</a
    >.
  </p>
  <button pButton type="button" (click)="logout()">Log af</button>
</div>

<div *ngIf="error === 'suprolesetup'">
  <h1>Ugyldig rolletildeling</h1>
  <p>
    Du er tildelt både rollen som forvalter supporter og én eller flere andre
    roller, hvilket ikke er tilladt. Kontakt KOMBIT helpdesk på 89 87 21 37
    eller
    <a href="mailto:helpdesk@serviceplatformen.dk"
      >helpdesk@serviceplatformen.dk</a
    >.
  </p>
  <button pButton type="button" (click)="logout()">Log af</button>
</div>

<div *ngIf="error === 'notkombit'">
  <h1>Ugyldigt CVR-nummer</h1>
  <p>
    Du er tildelt en KOMBIT-rolle, men dit CVR-nummer er ikke KOMBIT eller en
    anden forvalters. Kontakt KOMBIT helpdesk på 89 87 21 37 eller
    <a href="mailto:helpdesk@serviceplatformen.dk"
      >helpdesk@serviceplatformen.dk</a
    >.
  </p>
  <button pButton type="button" (click)="logout()">Log af</button>
</div>

<div *ngIf="!error">
  <h1>Ups, der opstod en uforudset fejl</h1>
</div>
